import type { StripeElementsOptions } from "@stripe/stripe-js";
import type { PropsWithChildren } from "react";

export type StripeProps = PropsWithChildren<{
  merchantIdentifier: string;
  elementsOptions?: StripeElementsOptions;
  publishableKey: string;
  urlScheme: string;
}>;

export type CreateBankAccParams = {
  accountNumber: string;
  currency: string;
  country: string;
};

export type CreateCardParams = {
  name?: string;
  currency?: string;
  address?: {
    city?: string;
    country?: string;
    line1?: string;
    line2?: string;
    postalCode?: string;
    state?: string;
  };
};

export enum PaymentSheetError {
  Failed = "Failed",
  Canceled = "Canceled",
  Timeout = "Timeout",
}
